<div>
  <div class="table-responsive always-scroll">
    <table class="table table-striped align-middle dashboard-table">
      <thead>
        <tr>
          <th>Profilbild</th>
          <th>Vollständiger Name</th>
          <th>E-Mail</th>
          <th>Erstellungsdatum</th>
          <th>Status</th>
          <th>Aktionen</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of users">
          <td>
            <img *ngIf="user.image" [src]="user.image" loading="lazy" alt="Vorschau" 
                 class="img-thumbnail" style="width: 50px; height: 50px;">
          </td>
          <td>
            <span class="text-lg-wrap text-lg-break">{{ user.fullName }}</span>
          </td>
          <td>
            <span class="text-lg-wrap text-lg-break">{{ user.email }}</span>
          </td>
          <td>
            {{ user.createdAt!.toDate() | date:'medium' }}
          </td>
          <td>
            <span [ngClass]="user.accountLocked ? 'text-danger' : 'text-success'">
              {{ user.accountLocked ? 'Inaktiv' : 'Aktiv' }}
            </span>
          </td>
          <td class="actions-col">
            <button class="btn btn-sm me-2"
                    [ngClass]="user.accountLocked ? 'btn-secondary' : 'btn-success'"
                    (click)="toggleUserStatus(user)">
              <i [class]="user.accountLocked ? 'fas fa-lock' : 'fas fa-unlock'"></i>
            </button>
            <button class="btn btn-danger btn-sm me-2">
              <i class="fas fa-trash"></i>
            </button>
            <button class="btn btn-info btn-sm" [routerLink]="['/Admin/UserDetails', user.id]">
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="users.length === 0 && showSpinner == false" style="text-align: center;">
          <td colspan="7" class="text-muted">Kein Benutzer verfügbar</td>
        </tr>
        <tr *ngIf="showSpinner" style="text-align: center;">
          <td colspan="7">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Lädt...</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>